import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CallToActionIcon from '@material-ui/icons/CallToAction';
import MuiTooltip from '@material-ui/core/Tooltip';

const defaultToolbarSelectStyles = theme => ({
    root: {
        backgroundColor: theme.palette.background.secondary,
        flex: '1 1 100%',
        display: 'flex',
        position: 'relative',
        zIndex: 120,
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: typeof theme.spacing === 'function' ? theme.spacing(1) : theme.spacing.unit,
        paddingBottom: typeof theme.spacing === 'function' ? theme.spacing(1) : theme.spacing.unit,
    },
    title: {
        paddingLeft: '26px',
    },
    iconButton: {
        marginRight: '24px',
    },
});

const MUIDataTableToolbarSelect = (props) => {
    const { classes, onRowsDelete, selectedRows, options, displayData, components = {} } = props;
    const textLabels = options.textLabels.selectedRows;
    const Tooltip = components.Tooltip || MuiTooltip;

    return (
        <Paper className={classes.root}>
            <Grid container direction='row' justify='space-between' alignItems='flex-start' spacing={2}>
                <Grid item>
                    <Typography variant="subtitle1" className={classes.title}>{selectedRows.data.length} {textLabels.text}</Typography>
                </Grid>
                {
                    options.bulkAction && (
                        <Grid item>
                            <Tooltip title={'Bulk Action'}>
                                <IconButton className={classes.iconButton} onClick={() => options.setBulkAction(selectedRows)} aria-label={textLabels.deleteAria}>
                                    <CallToActionIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    )
                }
            </Grid>
        </Paper>
    );
}

export default withStyles(defaultToolbarSelectStyles, { name: 'MUIDataTableToolbarSelect' })(MUIDataTableToolbarSelect)
